export interface ModalButton {
  text: string;
  fill?: 'clear' | 'outline' | 'solid';
  handler?: () => void;
  redirectPath?: string;
  color?: string;
  cssClass?: string;
}
